import React, { useEffect, useRef, useState } from 'react';
import styles from './Keyboard.module.scss';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { getTranslation } from '../../../utils/translation';

const NumericKeyboard = ({ inputValue, setInputValue, close, ...restProps }) => {
    const [input, setInput] = useState('');
    const [layout, setLayout] = useState({
        default: ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}', '{enter}'],
    });
    const keyboard = useRef();

    useEffect(() => {
        if (input != null && input !== inputValue) {
            keyboard.current.setInput(inputValue);
        }
    }, [inputValue]);

    const onChange = input => {
        setInput(input);
        console.log('Input changed', input);
    };

    const handleShift = () => {
        let newLayoutName = layout === 'default' ? 'shift' : 'default';
        setLayout(newLayoutName);
    };

    const onKeyPress = button => {
        if (button === '{enter}') {
            setInputValue(keyboard.current.input.default);
        }

        /**
         * If you want to handle the shift and caps lock buttons
         */
        if (button === '{shift}' || button === '{lock}') handleShift();
    };

    const onChangeInput = event => {
        let input = event.target.value;
        setInput(input);
        keyboard.current.setInput(input);
    };

    return (
        <div className={styles.numericKeyboard} {...restProps}>
            <button className={`${styles.closeButton} icon-close-thin`} onClick={close} />
            <input className={styles.inputPreview} value={input} onChange={onChangeInput} />
            <Keyboard
                keyboardRef={r => (keyboard.current = r)}
                layout={layout}
                onChange={input => onChange(input)}
                onKeyPress={button => onKeyPress(button)}
                display={{
                    '{enter}': getTranslation('numericKeyboardSubmit'),
                    '{bksp}': '<',
                }}
            />
        </div>
    );
};

export default NumericKeyboard;
